import React, { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';
import arePropsEqual from '../../../../helpers/arePropsEqual';
import { Field } from 'redux-form';
import FormField from '../../../atoms/Form/Field/FormField';
import FieldError from '../../Error/FieldError';
import styles from './TextData.css';
import getDummyData from '../../../../helpers/dummy';

const TextDataRender = React.memo(({
  input,
  placeholder,
  id,
  meta: { error, touched, initial },
}) => {
  if ((input.value || initial) === '') {
    return null;
  }

  const HtmlTextvalue =
    input.value.search(/\\n/g) >= 0
      ? input.value.replace(/\\n/g, '<br />')
      : input.value.search(/\n/g) >= 0
        ? input.value.replace(/\n/g, '<br />')
        : input.value;

  const initialTextValue =
    initial?.search(/\\n/g) >= 0
      ? initial?.replace(/\\n/g, '<br />')
      : initial?.search(/\n/g) >= 0
        ? initial?.replace(/\n/g, '<br />')
        : initial;

  return (
    <div className={styles.TextData}>
      <div id={id}>
        {input.value || initial ? (
          <div
            dangerouslySetInnerHTML={{ __html: input.value ? HtmlTextvalue : initialTextValue }}
          />
        ) : (
          placeholder
        )}
      </div>
      {touched && error && <FieldError error={error} />}
    </div>
  );
}, (oldProps, newProps) => {
  return arePropsEqual(oldProps, newProps);
});

TextDataRender.displayName = 'TextDataRender';

TextDataRender.propTypes = {
  input: PropTypes.object,
  placeholder: PropTypes.string,
  meta: PropTypes.shape({
    error: PropTypes.any,
    touched: PropTypes.bool,
    initial: PropTypes.string,
  }),
  id: PropTypes.string,
};

function TextData({ name, label, fieldHoC: FieldHOC = Field, validation, isPreview, ...props }) {
  const id = useMemo(() => uuid(), [name]);
  const initial = useMemo(() => (isPreview ? getDummyData(validation.type) : ''), [validation]);

  return (
    <FormField label={label} name={name} htmlFor={id}>
      <FieldHOC
        name={name}
        id={id}
        component={TextDataRender}
        meta={{ initial }}
        validation={validation}
        {...props}
      />
    </FormField>
  );
}

TextData.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  fieldHoC: PropTypes.func,
  validation: PropTypes.object,
  isPreview: PropTypes.bool,
};

export default TextData;
